import { Modal, Stack, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
// import Modal from 'react-modal'; // Ensure you have this installed: npm install react-modal
import Button from 'components/Common/CustomButton';
import client from 'api/apiClient';
import { useNavigate } from 'react-router-dom';

const InactivityTimer: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const inactivityTimer = useRef<any>(null);
    const navigation = useNavigate();
    // Function to reset the timer
    const resetTimer = () => {
        if (inactivityTimer.current) {
            clearTimeout(inactivityTimer.current);
        }
        inactivityTimer.current = setTimeout(
            async () => {
                client.clearTokens(); // Remove token from localStorage
                setIsModalOpen(true); // Show modal after 2 minutes of inactivity
            },
            6 * 60 * 1000
        ); // 6 minutes in milliseconds
    };

    const handleLogout = () => {
        navigation('/login'); // Replace with your login route
    };

    useEffect(() => {
        const events: string[] = ['mousedown', 'mousemove', 'keypress', 'keydown', 'scroll', 'touchstart'];

        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer(); // Initialize timer

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
            if (inactivityTimer.current) {
                clearTimeout(inactivityTimer.current);
            }
        };
    }, []);

    return (
        <Modal open={isModalOpen}>
            <Stack
                bgcolor="white"
                width={{ xs: '50%', md: '30%', lg: '20%' }}
                p={4}
                borderRadius={2}
                boxShadow={3}
                display="flex"
                flexDirection="column"
                alignItems="center"
                position="absolute"
                top="50%"
                left="50%"
                sx={{ transform: 'translate(-50%, -50%)' }}
                spacing={2}
            >
                <h2>Old Glory Pay</h2>
                <Typography textAlign={'center'}> Your session has timed out.</Typography>
                <Button variant="contained" onClick={handleLogout} sx={{ width: '100%' }} title="OK" />
            </Stack>
        </Modal>
    );
};

export default InactivityTimer;
